
import { computed, ComputedRef, defineComponent, PropType } from "vue";
import { Course } from "../../../../domain/entities/entities";
import { formattedDuration, isDecolaTemplate } from "../mixins";
import ModalIntroductoryContent from "./ModalIntroductoryContent.vue";
import VideoPlayButton from "./buttons/VideoPlay.vue";
import ButtonComment from "./DashboardComments/ButtonComment.vue";
import { useCarouselMouseEvents } from "../composables/carousel_mouse_events";

const __default__ = defineComponent({
  components: {
    ButtonComment,
    ModalIntroductoryContent,
    VideoPlayButton
  },
  props: {
    course: {
      type: Object as PropType<Course>,
      required: true
    }
  },
  setup(props, { emit }) {
    const backgroundImage: ComputedRef<string> = computed(() => {
      return `url(${props.course.imageURL})`;
    });

    const { isAllowedToClick: isAllowedToOpenComment } = useCarouselMouseEvents(
      "card__comments"
    );
    const { isAllowedToClick: isAllowedToOpenIntro } = useCarouselMouseEvents(
      "video-play-button"
    );
    const { isAllowedToClick: isAllowedToGoToCourse } = useCarouselMouseEvents(
      "card"
    );

    /** Boolean used to tell when a click event has been fired
     * from below the `div.card` in the DOM tree. */
    let hasLowLevelActions = false;

    const openComment = (): void => {
      if (isAllowedToOpenComment.value) {
        emit("loadCourseCommentsModal");
        hasLowLevelActions = true;
      }
    };

    const openIntroductoryContent = (): void => {
      if (isAllowedToOpenIntro.value) {
        emit("openIntroductoryContent");
        hasLowLevelActions = true;
      }
    };

    const goToCourse = async (): Promise<void> => {
      if (isAllowedToGoToCourse.value && !hasLowLevelActions) {
        emit("openCourse");
      }
      hasLowLevelActions = false;
    };

    const isNewCourse = (): boolean => {
      if (props.course.releaseStartDate && props.course.releaseEndDate) {
        return (
          getToday() >= props.course.releaseStartDate &&
          getToday() <= props.course.releaseEndDate
        );
      }
      return (
        getToday() >= props.course.releaseStartDate ||
        getToday() <= props.course.releaseEndDate
      );
    };

    const getToday = (): string => {
      return new Date().toISOString().slice(0, 10);
    };

    return {
      backgroundImage,
      isNewCourse,
      formattedDuration,
      openIntroductoryContent,
      openComment,
      goToCourse,
      isDecolaTemplate
    };
  }
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "17785c11": (_ctx.backgroundImage)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__